import JumpToAlipayCert from '@/common/components/alipayStudentCert/index.vue';
import AlipayCertCheck from '@/common/components/alipayStudentCert/check.vue';
import AlipayCertFail from '@/common/components/alipayStudentCert/fail.vue';
import urlUtil from '@/common/util/url';
import { alipayIdentityCert } from 'root/tqcz/modules/index.js';
import env from '@/common/util/env';
import storage from 'root/common/util/storage.js';

export default {
    data() {
        return {
            showJumpToAlipay: false, //跳转弹窗
            showAliIdCheck: false, //结果弹窗
            alipayVerifySuccess: false, //验证成功
            alipayVerifyFail: false, //认证失败
            isQueryAliStudentStatus: false,
            identityTimer: false,
            signUrl: '',
        };
    },
    beforeDestroy() {
        this.alipayVerifySuccess = false;
    },
    components: {
        JumpToAlipayCert,
        AlipayCertCheck,
        AlipayCertFail,
    },
    computed: {
        shouldVerifyIdentity() {
            return env.isApp;
        },
    },
    methods: {
        /***
         * params {
         *  skuId, //skuId
         *  phone, //手机号
         *  cancelUrl: '回退取消url'
         *  successUrl: '完成url',
         *  queryAndSign: 是否需要查询并签约
         *
         * }
         */
        // 接口调用
        async handleAliIdentityVerify(params) {
            const result = await this.handleQueryCertStatus(params);
            console.log(result, 'result');
            if (result?.code != 0) {
                window.ZZCFL.Toast(result?.msg);
                return;
            }
            return result?.data;
        },
        // 轮询
        async handleCheckAliPayVerifyStatus(params) {
            const data = await this.handleAliIdentityVerify(params);
            const { status } = data || {};
            if (status === 2) {
                this.resetPollingQuery(); //清除定时器
                this.handleAutoSubmit();
            } else if (status === 3) {
                console.log('签约失败');
                this.alipayVerifyFail = true;
                this.resetPollingQuery();
            } else {
                //'未签约' 或  '签约中'
                console.log(`未签约 或 签约中`);
            }
        },

        //认证成功时跳转
        handleAutoSubmit() {
            //签约成功
            this.alipayVerifySuccess = true;
            this.submit();
        },

        // 获取当前协议
        getSchemeByCurrentUrl() {
            const href = window.location.href;
            const completeUrl = urlUtil.pushQuery(
                href,
                { alipayStudentComplete: 1, autoSelectSkuId: this.skuId, account: this.phone },
                { dontEncode: ['ZZCAppArg'] }
            );
            const cancelUrl = urlUtil.pushQuery(
                href,
                { alipayStudentCancel: 1, autoSelectSkuId: this.skuId, account: this.phone },
                { dontEncode: ['ZZCAppArg'] }
            );
            console.log(completeUrl, cancelUrl, 'cancelUrl');
            const completeScheme = `blackunique://url/nopush?link=${encodeURIComponent(completeUrl)}`;
            const cancelScheme = `blackunique://url/nopush?link=${encodeURIComponent(cancelUrl)}`;
            console.log(completeScheme, cancelScheme, 'cancelUrl');
            if (env.isApp) {
                return {
                    completeScheme,
                    cancelScheme,
                };
            } else {
                return {
                    completeScheme: encodeURIComponent(completeUrl),
                    cancelScheme: encodeURIComponent(cancelUrl),
                };
            }
        },
        //查询认证状态
        async handleQueryCertStatus(params = {}) {
            return await alipayIdentityCert(params);
        },
        //清除定时器状态
        resetPollingQuery() {
            clearInterval(this.identityTimer);
            this.$loading && this.$loading.close();
        },
        // 轮询认证状态
        autoPollingVerifyStatus(params, times = 5) {
            this.$loading && this.$loading.open('加载中..');
            this.showAliIdCheck = false;
            if (this.identityTimer) clearInterval(this.identityTimer);
            let pollLeft = times;
            this.identityTimer = setInterval(() => {
                --pollLeft;
                if (pollLeft >= 0) {
                    // 轮询接口
                    this.handleCheckAliPayVerifyStatus(params);
                } else {
                    this.resetPollingQuery();
                    this.alipayVerifyFail = true;
                }
            }, 1000);
        },
        // 点击弹窗轮询
        handleQueryCertStatusByClick() {
            this.autoPollingVerifyStatus(
                {
                    skuId: this.skuId,
                    phone: this.phone,
                    queryAndSign: false,
                },
                3
            );
        },
        // 跳转支付宝交互
        handleJumpToAliVerify() {
            this.showAliIdCheck = true;
            setTimeout(() => {
                this.showJumpToAlipay = false;
                window.location.href = this.signUrl;
            }, 200);
        },
        // 支付宝完成认证状态
        checkVerifyCompleteStatus(query = {}) {
            if (!this.shouldVerifyIdentity) return;
            if (query?.alipayStudentComplete && query?.autoSelectSkuId && !this.isQueryAliStudentStatus) {
                this.isQueryAliStudentStatus = true;
                // 认证完成 进入轮询
                this.autoPollingVerifyStatus({
                    skuId: query?.autoSelectSkuId,
                    phone: query?.account?.split(' ')?.join('') || this.phone,
                    queryAndSign: false,
                });
            }
        },
        // 支付宝取消认证状态
        checkVerifyCancelStatus(query = {}) {
            if (!this.shouldVerifyIdentity) return;
            if (query?.alipayStudentCancel && !this.isQueryAliStudentStatus) {
                this.isQueryAliStudentStatus = true;
                //取消
                this.alipayVerifyFail = true;
            }
        },
        // 支付宝身份认证状态查询
        async checkStudentVerify() {
            if (this.isDiscountForStudent) {
                if (!this.shouldVerifyIdentity) {
                    window.ZZCFL.Toast('学生卡专属商品, 请购买其他商品');
                    return false;
                }
                if (this.alipayVerifySuccess) {
                    return true;
                }
                if (this.inputType !== 'phone') {
                    window.ZZCFL.Toast('学生卡专属商品, 请购买其他商品');
                    if (window.monitor) {
                        window.monitor.report({
                            level: 'info',
                            error: 'js',
                            url: window.location.href,
                            msg: `vueCaptureError --> 学生卡专属商品, 请购买其他商品`,
                        });
                    }
                    return false;
                }
                const { completeScheme, cancelScheme } = this.getSchemeByCurrentUrl();
                const params = {
                    skuId: this.skuId,
                    phone: this.phone,
                    successUrl: completeScheme,
                    cancelUrl: cancelScheme,
                    queryAndSign: true,
                };
                const result = await this.handleAliIdentityVerify(params);
                const { landingUrl, status } = result || {};
                console.log(status, 'status');
                if (status === 2) {
                    console.log('签约成功');
                    this.alipayVerifySuccess = true;
                    return true;
                }
                if (status === 0) {
                    //未签约
                    storage.set(storage.keys.lastSamePageByAliVerify, location.href);
                    storage.set(storage.keys.registerUrlByAliVerify, landingUrl);
                    this.signUrl = landingUrl || '';
                    console.log('landingUrl', landingUrl);
                    this.showJumpToAlipay = true; //跳转弹窗
                } else if (status === 3) {
                    console.log('签约失败');
                    this.alipayVerifyFail = true;
                }
                return false;
            }
            return true;
        },
    },
};
